import { getGtmClient } from 'marketing-site/lib/gtm'
import React, { useEffect } from 'react'
import kebabCase from 'lodash.kebabcase'
import { incrementMetric } from 'marketing-site/lib/frontendMetrics'

export const HeadPart: React.FC<{ nonce: string }> = ({ nonce }) => {
  return (
    <>
      <script
        nonce={nonce}
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `(function(){var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d});setTimeout(d,500)})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();`,
        }}
      />
      <script
        nonce={nonce}
        data-cfasync="false"
        src="https://client-registry.mutinycdn.com/personalize/client/d521f6885fb9b81e.js"
      />
    </>
  )
}

export const BodyPart: React.FC = () => {
  const recordExperimentImpression = async (
    experiment: string,
    variation: string,
  ): Promise<void> => {
    const gtmClient = await getGtmClient()

    if (gtmClient.pageviewId) {
      gtmClient.recordExperimentImpression({
        pageviewId: gtmClient.pageviewId,
        experiment,
        variation,
        experimentSource: 'mutiny',
      })
    } else {
      window.addEventListener(
        'gtm-js:record-pageview',
        () => recordExperimentImpression(experiment, variation),
        { once: true },
      )
    }
  }

  const handleMutinyEvent = async (event: any) => {
    const gtmClient = await getGtmClient()

    const { experience, audienceSegment, variationName, impressionType } = event.detail
    const experiment = experience
      ? `${kebabCase(audienceSegment)}_${kebabCase(experience)}`
      : kebabCase(audienceSegment)
    const variation = impressionType == 'control' ? impressionType : kebabCase(variationName)

    gtmClient.incrementMetric('GtmJS.MarketingSite.mutinyImpressionEvent', {
      location: 'MutinyBodyPart',
    })

    recordExperimentImpression(experiment, variation)
  }

  useEffect(() => {
    window.addEventListener('mutiny:experience-impression', handleMutinyEvent)
    return () => window.removeEventListener('mutiny:experience-impression', handleMutinyEvent)
  }, [])

  useEffect(() => {
    fetch('https://client-registry.mutinycdn.com/personalize/client/d521f6885fb9b81e.js')
      .then(() => incrementMetric('GtmJS.MarketingSite.mutinyAdBlockCheck', { blocked: 'false' }))
      .catch(() => incrementMetric('GtmJS.MarketingSite.mutinyAdBlockCheck', { blocked: 'true' }))
  })

  return <></>
}
